<template>
  <div>
    <v-card-text class="py-0">
      <div style='display: flex;'>
        <numberForm
          label="最小数"
          v-model="regulationItem.rules.minimumFrequency"
        ></numberForm>
        <keywordRankForm
          v-model="regulationItem.rules.targetRank"
        ></keywordRankForm>
        <postItemForm
          v-model="regulationItem.rules.targetItems"
          label='対象アイテム'
        ></postItemForm>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import numberForm from './forms/numberForm'
import keywordRankForm from './forms/keywordRankForm'
import postItemForm from './forms/postItemForm'

export default {
  name: 'RankKeywordFrequency',
  components: {
    numberForm,
    keywordRankForm,
    postItemForm
  },
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  },
  mounted: function () {
    if (!this.regulationItem.rules.targetItems) {
      this.regulationItem.rules = { targetItems: [] }
    }
  }
}
</script>
